import { render, staticRenderFns } from "./personnelSkills-list.vue?vue&type=template&id=e646dcec&scoped=true&"
import script from "./personnelSkills-list.vue?vue&type=script&lang=js&"
export * from "./personnelSkills-list.vue?vue&type=script&lang=js&"
import style0 from "./personnelSkills-list.vue?vue&type=style&index=0&id=e646dcec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e646dcec",
  null
  
)

export default component.exports